import axios from 'axios';
import { SERVER_URL } from '../constants/url';
import CODE from '../constants/code';
import URL from '../constants/url';
import MSG from '../constants/message';
import { getDpAuthRefeshTokenSimple, getLoadingHandler } from '../assets/js/comm';

// 김하용, axios 기본 베이스 인스턴스 생성
const instance = axios.create({
    baseURL: SERVER_URL
    , headers : {
        'Content-type': 'application/json'
    }
    , withCredentials: true
});

// Access Token 갱신 중복 호출 방지용 Promise
// 동시에 여러 요청에서 401이 발생해도 하나의 갱신 작업만 실행한다.
let refreshPromise = null;

// 인증 실패 처리 중복 방지
let isAuthFailHandling = false;

// 김하용, 고정 인터셉트 전처리 // Request Config (options) 을
instance.interceptors.request.use(
    (options) => {
      if (!options['noLoading']) {
          const setLoading = getLoadingHandler();
          if (setLoading) setLoading(true); // 전역 로딩셋
      }

      if(options['baseURL'] === SERVER_URL) {
          if (!options['origin']) {
              options = { ...options, origin: SERVER_URL };
          }
      }
      /* 김하용, default 는 변경하지 않도록 한다.
      else {
        //instance.defaults.baseURL = options.baseURL;
        //instance.defaults.origin = options.baseURL;
        //instance.defaults.withCredentials = true;
      }
      */
      return options;
    },
  (error) => {
      const setLoading = getLoadingHandler();
      if( setLoading ) setLoading(false); // 전역 로딩해제
    return Promise.reject(error);
  }
);

// Access Token 갱신 처리
const refreshAccessToken = async () => {

    const loginUser = JSON.parse(
        sessionStorage.getItem("loginUser") || "{}"
    );

    if (!loginUser?.usrUid || !loginUser?.crtfcTknVal) {
        throw new Error("세션 정보가 없습니다.");
    }

    console.log("Access Token 갱신 시작");

    // 인증 서버에서 Access Token / Refresh Token 재발급
    const data = await getDpAuthRefeshTokenSimple(
        loginUser.crtfcTknVal
    );

    const { accessToken, refreshToken } = data;

    if (!accessToken || !refreshToken) {
        throw new Error("토큰 갱신 응답이 올바르지 않습니다.");
    }

    console.log("인증 서버 토큰 발급 완료");

    const requestCdssUrl = SERVER_URL + "/signup/saveRefreshToken";

    const userReq = {
        crtfcTknVal: refreshToken,
        usrInfoId: loginUser.usrInfoId,
        usrUid: loginUser.usrUid,
    };

    const requestOptions = {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        withCredentials: true,
    };

    // 새 Refresh Token 서비스 서버 저장
    const refreshResp = await axios.post(
        requestCdssUrl,
        userReq,
        requestOptions
    );

    if (
        Number(refreshResp.data.resultCode) !==
        Number(CODE.RCV_SUCCESS)
    ) {
        throw new Error("리프레쉬 토큰 업데이트에 실패하였습니다.");
    }

    // Access Token 저장
    localStorage.setItem("jToken", accessToken);
    localStorage.setItem("IITP_CRTFC_TKN", refreshToken);

    // axios 기본 Authorization 갱신
    axios.defaults.headers.common['Authorization'] =
        `Bearer ${accessToken}`;

    // 현재 axios instance 기본 Authorization 갱신
    instance.defaults.headers.common['Authorization'] =
        `Bearer ${accessToken}`;

    // 사용자 세션 정보 갱신
    sessionStorage.setItem(
        "loginUser",
        JSON.stringify(refreshResp.data.result.iitpUser)
    );

    console.log("Access Token 갱신 전체 완료");

    return accessToken;
};

// 김하용, 고정 인터셉트 후처리
instance.interceptors.response.use(
    (resp) => {
        if (!resp.config?.noLoading) {
            const setLoading = getLoadingHandler();
            if (setLoading) setLoading(false);
        }

        if (Number(resp.data.resultCode) === Number(CODE.RCV_ERROR_AUTH)) {
            alert(MSG.ERR_SESSION);
            localStorage.setItem('jToken', "");
            sessionStorage.setItem("loginUser", JSON.stringify({}));
            window.location.href = URL.MAIN;
            return false;
        }

        return resp;
    },
    async (error) => {

        if (!error.config?.noLoading) {
            const setLoading = getLoadingHandler();
            if (setLoading) setLoading(false);
        }

        const originalRequest = error.config;

        if (error.code === "ERR_NETWORK") {
            alert(MSG.ERR_NETWORK);
            return Promise.reject(error);
        }

        // response 또는 config가 없는 경우
        if (!error.response || !originalRequest) {
            return Promise.reject(error);
        }

        const baseURL = originalRequest.baseURL || "";

        // baseURL 포함 여부 논리 수정: 두 URL 모두 포함하지 않을 때만 실행
        if (
            !baseURL.includes("api-auth.dgtpharm.com") &&
            !baseURL.includes("dev-api-auth.dgtpharm.com")
        ) {

            // 재시도 플래그를 활용해 무한루프 방지
            if (
                error.response.status === Number(CODE.RCV_BAD_UNAUTH) &&
                !originalRequest._retry
            ) {

                originalRequest._retry = true;

                try {

                    /*
                     * 현재 localStorage에 저장된 Access Token과
                     * 401이 발생한 요청에서 사용한 Access Token을 비교한다.
                     *
                     * 두 토큰이 다르다면 다른 요청에서 이미
                     * Access Token 갱신이 완료된 상태이므로
                     * Refresh Token을 다시 사용하지 않고
                     * 현재 Access Token으로 원 요청만 재시도한다.
                     */
                    const currentAccessToken =
                        localStorage.getItem("jToken");

                    const requestAuthorization =
                        originalRequest.headers?.Authorization ||
                        originalRequest.headers?.authorization;

                    if (
                        currentAccessToken &&
                        requestAuthorization &&
                        requestAuthorization !== `Bearer ${currentAccessToken}`
                    ) {

                        console.log(
                            "이미 다른 요청에서 Access Token 갱신 완료 - 현재 토큰으로 재요청"
                        );

                        originalRequest.headers = {
                            ...(originalRequest.headers || {}),
                            Authorization: `Bearer ${currentAccessToken}`,
                        };

                        return instance(originalRequest);
                    }

                    /*
                     * 현재 진행 중인 Access Token 갱신 작업이 없을 때만
                     * 실제 Refresh Token을 사용하여 인증 서버를 호출한다.
                     *
                     * 동시에 여러 요청에서 401이 발생한 경우
                     * 첫 번째 요청만 refreshAccessToken()을 실행하고
                     * 나머지 요청은 동일한 refreshPromise 결과를 기다린다.
                     */
                    if (!refreshPromise) {

                        console.log(
                            "Access Token 갱신 작업 없음 - 새 갱신 작업 시작"
                        );

                        refreshPromise = refreshAccessToken()
                            .finally(() => {

                                // 성공/실패 관계없이
                                // 현재 갱신 작업이 끝났으므로 Promise 초기화
                                refreshPromise = null;
                            });

                    } else {

                        console.log(
                            "이미 Access Token 갱신 중 - 기존 갱신 작업 대기"
                        );
                    }

                    // 동시에 발생한 모든 401 요청이
                    // 동일한 Access Token 갱신 결과를 기다린다.
                    const accessToken = await refreshPromise;

                    // 새 Access Token으로 기존 요청 Authorization 변경
                    originalRequest.headers = {
                        ...(originalRequest.headers || {}),
                        Authorization: `Bearer ${accessToken}`,
                    };

                    // 기존 요청 재요청
                    return instance(originalRequest);

                } catch (err) {

                    console.log(err);

                    /*
                     * 동시에 여러 요청이 refreshPromise를 기다리고 있다가
                     * 갱신에 실패한 경우 alert / redirect가
                     * 여러 번 실행되는 것을 방지한다.
                     */
                    if (!isAuthFailHandling) {

                        isAuthFailHandling = true;

                        if (
                            err?.message ===
                            "리프레쉬 토큰 업데이트에 실패하였습니다."
                        ) {
                            alert("리프레쉬 토큰 업데이트에 실패하였습니다.");
                        } else {
                            alert("인증정보 업데이트에 실패하였습니다.");
                        }

                        localStorage.setItem("jToken", "");
                        sessionStorage.setItem(
                            "loginUser",
                            JSON.stringify({})
                        );

                        window.location.href = URL.MAIN;
                    }

                    return Promise.reject(err);
                }
            }
        }

        return Promise.reject(error);
    }
);

export default instance;